@import 'styles/mixins';
@import 'styles/variables';

.root {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
}

.menuScrollWrapper {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.header {
  align-items: center;
  display: flex;
  gap: 7px;
  padding: 2px;
}

.divider {
  border-top: 1px solid var(--dark-4);
  margin: 4px;
}

.workspacePopover {
  background-color: var(--glass-sidebar-background-color, var(--sidebar-background-color));
}

.workspaceMenuItemContent {
  display: flex;
  align-items: center;
  overflow: hidden;
  flex: 1;
  column-gap: 8px;

  .badge {
    color: var(--light-100);
    background-color: var(--light-10);
  }
}

.workspaceMenuItemName {
  @include line-clamp;
  flex: 1;
  padding-bottom: 1px;
}

.workspaceMenuItemActions {
  position: absolute;
  right: 6px;
  opacity: 0;

  &.noAutopilot {
    position: static;
    right: auto;
  }
}

.menuItem:hover {
  .workspaceMenuItemActions {
    opacity: 1;
  }
  .autopilotPill {
    opacity: 0;
  }
}

.autopilotPill {
  @include sm-regular;

  display: flex;
  padding: 2px 6px;
  align-items: center;
  border-radius: 16px;
  background: linear-gradient(
      270deg,
      var(--Magenta-50, rgba(182, 75, 248, 0.2)) 0%,
      var(--Blue-70, rgba(1, 121, 207, 0.2)) 100%
    ),
    var(--background, #f3f5f6);
  color: var(--purple-70);
  text-align: center;
  transition: opacity 0.2s ease-in-out;
}
